import { eTransactionCategory } from '../../../ui-toolkit/enums/eTransactionType';
import {
  eCreateSigningAppointmentFormDataOwnerTypes,
  getConsumerTypeFromFormDataOwnerType,
  isDigitalSchedulingOwnerType,
} from '../../../types/order/consumer/eCreateSigningAppointmentFormDataOwnerTypes';
import { eConsumerTypes } from '../../../types/order/consumer/eConsumerTypes';

const labelBuilder = (
  baseLabel: string,
  correctionText: string,
  emailConfirmationText: string,
  shortTitle?: boolean
) => {
  if (shortTitle) {
    return `${baseLabel} ${correctionText}Appointment`;
  }
  return `${baseLabel} ${correctionText}Appointment${emailConfirmationText}`;
};

export const getSigningAppointmentOwnerTypeDisplayLabel = (
  ownerType: eCreateSigningAppointmentFormDataOwnerTypes,
  orderTransactionCategory: eTransactionCategory,
  isCorrection: boolean,
  shortTitle?: boolean
): string => {
  const correctionText = isCorrection ? 'Correction ' : '';
  const emailConfirmationText = isDigitalSchedulingOwnerType(ownerType) ? ' With Email Confirmation' : '';

  if (getConsumerTypeFromFormDataOwnerType(ownerType) === eConsumerTypes.seller) {
    return labelBuilder('Seller', correctionText, emailConfirmationText, shortTitle);
  }

  if (getConsumerTypeFromFormDataOwnerType(ownerType) === eConsumerTypes.borrower) {
    if (orderTransactionCategory === eTransactionCategory.Purchase) {
      return labelBuilder('Buyer', correctionText, emailConfirmationText, shortTitle);
    }
    if (orderTransactionCategory === eTransactionCategory.Refinance) {
      return labelBuilder('Borrower', correctionText, emailConfirmationText, shortTitle);
    }
    throw Error(`Invalid transaction category ${orderTransactionCategory} for borrower`);
  }

  throw Error(`Invalid owner type ${ownerType} for signing appointment`);
};
